// @core/stores/license/LicenseLicenseStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { licenseApi } from '@core/api';
import type {
  CheckLicenseRequest,
  CheckLicenseResponse,
  HeartbeatRequest,
  HeartbeatResponse,
} from '@core/types/license';

class LicenseLicenseStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Check license
   */
  async CheckLicense(data: CheckLicenseRequest): Promise<CheckLicenseResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await licenseApi.CheckLicense(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Heartbeat 
   */
  async Heartbeat(data: HeartbeatRequest): Promise<HeartbeatResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await licenseApi.Heartbeat(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const licenseLicenseStore = new LicenseLicenseStore();
